<template>
  <div class="expendDetailPage" v-if="!showLoad">
    <ul v-if="detailList.length != '0'">
       <li v-for="item in detailList" :key="item.id">
        <div class="incomeInfo">
          <p>支出类型：{{item.typeName}}</p>
          <p>支出时间：{{item.createTime}}</p>
          <p>支出金额：{{item.amount}}元</p>
          <p>备注：{{item.remarks}}</p>
        </div>
      </li>
    </ul>
     <div class="nonePage" v-if="detailList.length == '0' && refreshing">
      <img :src="baseUrl+'empty.png'" alt />
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
import newApi from "lodash";
export default {
  name: "incomeDetail",
  data() {
    return {
       baseUrl: process.env.BASE_URL,
      detailList: [],
       pageNum:1,
      pageSize:100,
      baseData:{
        dateUnitType:"all",
        projectId:"",  
      },
      refreshing:false
    };
  },
  mounted() {
     this.baseData.projectId = this.$route.query.commonId; //项目Id
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
     let _this = this;
      _this.setShowLoad(false); //加载状态，默认为true加载
       _this.$api.project
        .projectExpensesDetail(_this.pageNum,_this.pageSize,_this.baseData)
        .then(res => {
          if (res.code == "1") {
            _this.detailList = res.data.list;
            
          } else {
            _this.$toast(res.msg);
          }
           _this.refreshing=true;
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.expendDetailPage {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  ul {
    width: 100%;
     height: 100%;
    overflow-y: scroll;
     background-color: #f6f6f6;
    padding: 0 16px;
    li {
      width: 100%;
      padding: 8px 8px;
      margin: 10px 0;
      background-color: #fff;
      border: 1px solid #eeeeee;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      .incomeInfo {
        p {
          width: 100%;
          overflow: hidden;
          font-size: 15px;
          line-height: 20px;
          margin: 5px 0;
          color: #333;
        }
      }
    }
  }
    .nonePage {
    width: 120px;
    height: 135px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -67px;
    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
}
</style>